// Screenname:Tax master
// Developer Name: Jagadish.
// Created date on: 2 / 2 / 2023
// Comments and Suggestions:
// TS File: Service
// Messages:
import httpbaseURL from "../common/axios";
class Taxservices {
  createdata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/TaxMAS/Create", doc);
  }
  getdata() {
    return httpbaseURL.httpMSInventoryUrl.get("/TaxMAS/List");
  }
  GetTaxTable(HospitalId) {
    return httpbaseURL.httpMSInventoryUrl.get("/TaxMAS/TaxMasList?HospitalId=" + HospitalId);
  }
  getfindonedata(doc, HospitalId) {
    return httpbaseURL.httpMSInventoryUrl.get("/TaxMAS/Get?id=" + doc + "&HospitalId=" + HospitalId);
  }

  updatedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/TaxMAS/Update", doc);
  }

  deletedata(doc, HospitalId) {
    return httpbaseURL.httpMSInventoryUrl.delete(
      "/TaxMAS/Delete?id=" + doc + "&HospitalId=" + HospitalId
    );
  }

  active(doc, Status, HospitalId) {
    return httpbaseURL.httpMSInventoryUrl.put(
      "/TaxMAS/Active?Id=" + doc + "&Status=" + Status + "&HospitalId=" + HospitalId
    );
  }

  GetTaxTypes(HospitalId) {
    return httpbaseURL.httpMSInventoryUrl.get("/TaxTypes/List?HospitalId=" + HospitalId);
  }

  GetTaxlistByTaxType(HospitalId, Taxtype) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/TaxMAS/GetTaxlistByTaxType?HospitalId=" +
      HospitalId +
      "&Taxtype=" +
      Taxtype
    );
  }
}
export default new Taxservices();
